import { render, staticRenderFns } from "./registerUserList.vue?vue&type=template&id=01123ef4&"
import script from "./registerUserList.vue?vue&type=script&lang=js&"
export * from "./registerUserList.vue?vue&type=script&lang=js&"
import style0 from "./registerUserList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports